import React from "react";

const TermsAndConditions = () => {
  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <h1>Terms and Conditions of Use</h1>
      <p>
        Your use or access of our website or services, including any readings, forecasts, communications, or games (collectively, the “Services”) is governed by the following terms and conditions (as may be amended by us at our sole discretion, without notice to you, from time to time). Your use of the Services at any given time shall constitute irrevocable acceptance of the terms applying at the time of use.
      </p>
      <p>
        A reference to the ‘Company’ means Xianhe Pte Ltd, including its affiliate(s) where relevant.
      </p>
      <ol>
        <li>
          <strong>Nature of Service</strong>
          <p>
            You accept and confirm your understanding that the Services do not, in any form, constitute professional advice, and should not be regarded by you in any way as legal, financial, medical, psychological, or any other form of professional advice. You are solely responsible for ensuring that you consult any relevant professional for specific advice or consultation, as you may deem fit, and that nothing in the Services shall be understood as, or used by, you as a substitute for advice which an appropriately qualified professional with the relevant experience should be engaged to provide. You release the Company from any responsibility or liability entirely in relation to any acts, or failure to act, which you may elect to do or omit to do in connection with any communication or information generated by your use of the Services.
          </p>
        </li>
        <li>
          <strong>Non-Reliance</strong>
          <ul>
            <li>You understand and fully accept the nature of the Services;</li>
            <li>No information provided in connection with the Services, howsoever communicated, shall create any warranty or representation;</li>
            <li>Any statements or communications provided as part of the Services are speculative in nature, and must not be regarded by you to be accurate, complete, and/or correct; and</li>
            <li>Any decisions you may elect to make based on information provided in connection with the Services are made solely at your own discretion and risk.</li>
          </ul>
        </li>
        <li>
          <strong>Assumption of Risk</strong>
          <ul>
            <li>Your use of the Services is entirely at your own risk;</li>
            <li>The Services may not be accurate, correct, and no outcome in relation to any readings or communications is guaranteed;</li>
            <li>You shall be solely responsible for the decisions, actions, or consequences arising out of your use of the Services; and</li>
            <li>The Company shall not be held liable for any direct, indirect, incidental, consequential or punitive damages resulting from your use of the Services.</li>
          </ul>
        </li>
        <li>
          <strong>Privacy</strong>
          <p>
            By using the Services, you agree that the Company may collect, use, and disclose your personal data in accordance with the Singapore Personal Data Protection Act 2012 (“PDPA”).
            We collect certain personal information such as your <strong>name, email address, date of birth, and Chinese date of birth</strong> to provide personalized forecasts and related services.
          </p>
          <ul>
            <li>
              <strong>Accuracy:</strong> You must ensure that your date of birth and Chinese date of birth are accurate. Incorrect information may result in inaccurate forecasts or analyses.
            </li>
            <li>
              <strong>Purpose:</strong> This information is used solely to generate your Ba Zi life chart forecast and to tailor our content, recommendations, and services to you.
            </li>
          </ul>
          <p>
            If you have any questions or wish to withdraw your consent, please contact us at <a href="mailto:contact@xianhefairy.com">contact@xianhefairy.com</a>.
          </p>
        </li>
        <li>
          <strong>Marketing and Communication</strong>
          <ul>
            <li>By providing your email address, you agree that we may use it to send updates, newsletters, promotional offers, and marketing materials related to our Services.</li>
            <li>We may communicate service updates, personalized content, or recommendations.</li>
            <li>You may opt out of marketing emails at any time by clicking the “unsubscribe” link in any of our messages or by contacting us directly.</li>
          </ul>
        </li>
        <li>
          <strong>Age Restriction</strong>
          <ul>
            <li>You confirm your understanding that a user of the website and/or the Services must be at least 18 (eighteen) years of age.</li>
            <li>By using this website and/or the Services, you warrant that you are at least 18 years of age.</li>
          </ul>
        </li>
        <li>
          <strong>Intellectual Property</strong>
          <p>
            All content, data, and materials owned by us, generated by or used to operate our website or the Services, including but not limited to user interactions, analytics, images, descriptions, and aggregated information, are the sole property of the Company (or, as relevant, any licensors engaged in connection with the Services). Nothing in the Services or these terms shall be construed as conferring any rights or license to you. You also agree that you will not copy, reproduce, download or distribute any of the Company’s intellectual property in any way, including electronic, digital, or new trademark registrations.
          </p>
          <p>
            You agree to grant us a non-exclusive, worldwide, perpetual, royalty-free license to use, reproduce, modify, adapt, publish and share content (or information) submitted to our website, or the Services, and expressly grant the Company a perpetual, worldwide, royalty-free license to use, reproduce, modify, adapt, publish and share any content or information generated from materials, information, or images taken from or generated by your use of the Services which you post on your social media accounts.
          </p>
        </li>
        <li>
          <strong>User Accounts</strong>
          <p>
            As a user of this website, you may be asked to register with us and provide private information. You are responsible for ensuring the accuracy of this information, and you are responsible for maintaining the safety and security of your information. You are also responsible (and shall be held responsible) for all activities that occur under your account or password.
          </p>
          <p>
            If you think there are any possible issues regarding the security of your account on the website, you must inform us immediately so we may address them accordingly.
          </p>
          <p>
            We reserve all rights to terminate accounts, edit or remove content and cancel orders at our sole discretion.
          </p>
        </li>
        <li>
          <strong>Refund Policy</strong>
          <p>
            All goods and services sold are non-exchangeable, non-refundable, and non-returnable, unless otherwise stated or required by applicable consumer protection laws in Singapore.
          </p>
          <p>
            You confirm that, prior to any purchase, you have reviewed all relevant descriptions and details and accept that no refunds are available in relation to any purchase made on this website.
          </p>
          <p>
            <strong>Chargeback Clause:</strong> By confirming your purchase, you acknowledge and agree that all sales are final and non-refundable. Any chargeback or payment dispute initiated with your payment provider will be considered a breach of these terms, and the Company reserves the right to dispute such chargebacks and take appropriate legal action.
          </p>
          <p>
            <strong>Confirmation Checkbox:</strong> You must tick the box confirming that you have read the terms, and that you understand and agree that your purchase is final and non-refundable before completing any transaction.
          </p>
        </li>
        <li>
          <strong>GST and Payment Details</strong>
          <p>
            All payments are received into the GST-registered company account of Xianhe Pte Ltd, 68 Circular Road, #02-01, Singapore 049422. For security and compliance, your IP address and mobile phone number may be logged at the time of transaction.
          </p>
        </li>
        <li>
          <strong>Governing Law</strong>
          <p>
            These terms shall be governed by and construed in accordance with the laws of the Republic of Singapore, regardless of your location. You agree to submit to the exclusive jurisdiction of the Singapore courts.
          </p>
        </li>
        <li>
          <strong>Indemnity</strong>
          <p>
            You agree to indemnify, defend, and hold harmless the Company, its directors, officers, employees, and agents from and against any and all claims, damages, losses, liabilities, costs, and expenses arising from or related to:
          </p>
          <ul>
            <li>Your use or misuse of the website or the Services;</li>
            <li>Your violation of our terms and conditions;</li>
            <li>Any content you submit, post, or share generated from the Services;</li>
            <li>Any infringement or alleged infringement of intellectual property rights or other rights of any third party; and/or</li>
            <li>Any breach of applicable laws or regulations.</li>
          </ul>
        </li>
        <li>
          <strong>Limitation of Liability</strong>
          <p>
            To the fullest extent permitted by law, the Company shall not be liable for any loss, damage, or expense, whether direct or indirect, incidental, consequential, or special, arising out of your use or access of this website or the Services. The Company makes no warranties or representations, express or implied, regarding the operation or availability of the website or the information, content, materials or products included on it.
          </p>
        </li>
        <li>
          <strong>Entire Agreement</strong>
          <p>
            These terms set out the entirety of the agreement between the Company and you, and shall supersede all prior agreements or understandings, whether written or oral.
          </p>
        </li>
      </ol>
    </div>
  );
};

export default TermsAndConditions;